<div class="container-fluid p-6">
    <div class="row mb-4">
        <div class="col">
            <h6 class="mb-2">ENTWICKLUNG EINER GEWINNSPIEL MICROSITE</h6>
            <h2>Jubel Deal - Gewinnspiel für ALDI Suisse</h2>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-xl-4">
            <img src="/assets/images/references/ref-jubeldeal-screen.jpg"
                 class="img-fluid" />
        </div>
        <div class="col-xl-8">
            <p>
                coop.media ist eine Berliner Design Agentur, die sowohl Online- als auch Offline Designprojekte betreut und umsetzt.
            </p>
            <p>
                Für den Kunden ALDI Suisse sollte anlässlich der Feier zur 200. eröffneten ALDI Suisse Filiale, ein Online Gewinnspiel umgesetzt werden, bei dem Kunden durch Eingabe eines Codes am Spiel teilnehmen konnten.
            </p>
            <p>
                Für das Projekt bildeten coop.media mit ihrem ausgeprägten Design-Fokus und aheadware mit ihrer technischen Expertise eine ideale Partnerschaft.
            </p>
        </div>

    </div>
<!--
    <div class="row" style="margin-top: 3rem">
        <div class="ref-page-header-image"
             style="background-image: url(/assets/images/references/ref-jubeldeal.jpg)"></div>
    </div>
    -->
    <div class="row" style="margin-top: 5rem">
        <div class="col-xl-4">
            <h2>TASK & CHALLENGE</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Ziel des Projekts war die Entwicklung einer Microsite für eine Online-Spiele-Verlosung von ALDI Suisse, die ein ansprechendes und funktionales Nutzererlebnis bietet. Eine der zentralen Aufgaben bestand darin, die genauen Designvorgaben des Kunden pixelgenau in ein responsives Layout zu überführen, das auf allen Geräten und Bildschirmgrößen einheitlich und benutzerfreundlich dargestellt wird.
            </p>
            <p>
                Eine weitere Herausforderung lag in der Lokalisierung der Microsite in drei Sprachen, wobei die Inhalte teilweise über unterschiedliche Domains ausgeliefert wurden. Zusätzlich war die nahtlose Anbindung an verschiedene Backendsysteme erforderlich, darunter ein Service für den automatisierten Versand von E-Mails.
            </p>
            <p>
                Besondere Aufmerksamkeit wurde den strengen IT-Sicherheitsanforderungen gewidmet, um sowohl die Integrität der Daten als auch den Schutz der Nutzerdaten zu gewährleisten. Die Kombination aus präziser Designumsetzung, Mehrsprachigkeit, Backend-Integration und Einhaltung höchster Sicherheitsstandards machte dieses Projekt technisch und organisatorisch anspruchsvoll.
            </p>
            <img src="/assets/images/references/ref-jubeldeal-cover.jpg" class="img-fluid" />
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-xl-4">
            <h2>SOLUTION</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die entwickelte Microsite überzeugte durch eine designgetreue Umsetzung, die die Vorgaben von ALDI Suisse pixelgenau in ein modernes, responsives Layout überführte. Sie bietet ein einheitliches und ansprechendes Nutzererlebnis auf allen Geräten und Bildschirmgrößen.
            </p>
            <p>
                Technisch wurde die Microsite hochperformant realisiert, mit einer robusten und sicheren Architektur, die den strengsten Anforderungen gerecht wird. Besonders hervorzuheben ist, dass sie erfolgreich den anspruchsvollsten Penetrationstests standhielt und damit höchste Sicherheitsstandards erfüllte.
            </p>
            <div style="margin-top: 2rem">
                <h4>TECHNOLOGIEN</h4>
                <div class="tech-icons">
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/Infront JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/HTML5 CSS3@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/SQL@2x-1.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-12">
            <div class="p-2 p-lg-5" style="border: 1px solid white;">
                <p>
                    “Die aheadware GmbH hat bei der technischen Umsetzung der Online-Gewinnspielseite für die "Jubel Deal"-Kampagne von Aldi Suisse großartige Arbeit geleistet. Die Plattform überzeugt durch ihre Stabilität, Performance und eine reibungslose Nutzererfahrung – ein wichtiger Beitrag zum Erfolg des Projekts.”
                </p>
                <p>
                    <i>Ilja Ionov, Inhaber coop.media</i>
                </p>
            </div>
        </div>
    </div>
</div>
